import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from "react-toastify";
import axios from "axios";
import { config } from '../../utils/config';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import ImageAdd from '../../components/ImageAdd/ImageAdd';
import { Tag, Button } from 'antd';
import { SaveOutlined, PlusOutlined } from '@ant-design/icons';

const smstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: "12px",
    p: 2,
    maxHeight: 600,
    overflow: "scroll",
    color: "black",
};

export default function VairantTables({
    productTypeNmae,
    id,
    setdataSet,
    dataSet,
    datatype,
    submitFun,
    variatType,
    productIdVariantsData,
    tableData,
    settableData,
    hasVariants,
    product,
    upDateVariantsHandler,
    manDatoryAttr,
    getVariantsData,
    handleOpen,
    handleClose,
    deletHandlerWhileCreate,
    handleAddManualVariantRow
}: any) {
    const { baseNodeapiUrl, apiEndpoint } = config;
    const [iopen, setiopen] = useState(false);
    const [currentImageRowIndex, setCurrentImageRowIndex] = useState<number>(0);
    const [isUpdating, setIsUpdating] = useState(false);
    const [warehouses, setWarehouses] = useState<any[]>([]);

    React.useEffect(() => {
        const fetchWarehouses = async () => {
            try {
                const token = sessionStorage.getItem("token");
                const headers = {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${token}`
                };
                let res;
                try {
                    res = await axios.get(`${apiEndpoint}/snp/warehouse/get`, { headers });
                } catch (e1) {
                    try {
                        res = await axios.get(`${baseNodeapiUrl}/digidukaan/snp/warehouse/get`, { headers });
                    } catch (e2) {
                        res = await axios.get(`${baseNodeapiUrl}/snp/warehouse/get`, { headers });
                    }
                }
                const list = res?.data?.data || (Array.isArray(res?.data) ? res?.data : []);
                setWarehouses(list);
            } catch (err) {
                console.log("Error fetching warehouses in VairantTables:", err);
            }
        };
        fetchWarehouses();
    }, [apiEndpoint, baseNodeapiUrl]);

    // Update specific field in a variant row
    const handleFieldChange = (index: number, field: string, value: any) => {
        settableData((prev: any[]) => {
            const updated = [...prev];
            const currentItem = {
                ...updated[index],
                [field]: value
            };
            if (field === "mrp") {
                currentItem.base_price = value;
            }
            if (field === "selling_price") {
                currentItem.current_price = value;
                currentItem.tax_included_price = value;
            }
            if (field === "uom_value") {
                currentItem.weight = value;
                currentItem.weights = value;
            }
            if (field === "weight" || field === "weights") {
                currentItem.uom_value = value;
            }

            updated[index] = currentItem;
            return updated;
        });
    };

    // Delete a variant row
    const handleDeleteRow = (index: number) => {
        settableData((prev: any[]) => {
            const updated = [...prev];
            updated.splice(index, 1);
            return updated;
        });
        toast.info("Variant row removed");
    };

    // Image Upload
    const handleImageUpload = async (e: any, index: number) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
        }

        try {
            const { data } = await axios.post(
                `${baseNodeapiUrl}/digidukaan/snp/upload`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                    }
                }
            );

            if (data?.success) {
                toast.success("Image uploaded successfully!");
                const locations = data.urls || [];
                settableData((prev: any[]) => {
                    const updated = [...prev];
                    const existingImages = Array.isArray(updated[index]?.image)
                        ? updated[index].image
                        : (updated[index]?.image ? [updated[index].image] : []);
                    updated[index] = {
                        ...updated[index],
                        image: [...existingImages, ...locations]
                    };
                    return updated;
                });
            } else {
                toast.error("Upload failed!");
            }
        } catch (err) {
            console.error("Upload error:", err);
            toast.error("Image upload failed!");
        }
    };

    // Open image modal
    const handleOpenImageModal = (index: number) => {
        setCurrentImageRowIndex(index);
        setiopen(true);
    };

    // Remove single image from row
    const handleRemoveImage = (imgIdx: number) => {
        settableData((prev: any[]) => {
            const updated = [...prev];
            const images = Array.isArray(updated[currentImageRowIndex]?.image) ? [...updated[currentImageRowIndex].image] : [];
            images.splice(imgIdx, 1);
            updated[currentImageRowIndex] = {
                ...updated[currentImageRowIndex],
                image: images
            };
            return updated;
        });
    };

    const handleSaveClick = async () => {
        setIsUpdating(true);
        try {
            if (hasVariants === "true" || hasVariants === true || id || product?.id) {
                await upDateVariantsHandler(tableData, variatType);
            } else {
                submitFun(tableData, variatType, "create");
            }
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <div className='mt-3'>
            <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap" style={{ gap: "10px" }}>
                <div>
                    <h6 style={{ fontWeight: 700, color: "#1E293B", margin: 0 }}>
                        Variants List ({tableData?.length || 0})
                    </h6>

                </div>
            </div>

            <Paper sx={{ width: '100%', overflow: 'hidden', border: "1px solid #E2E8F0", borderRadius: "12px", boxShadow: "0 4px 20px rgba(15, 23, 42, 0.05)" }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow sx={{
                                "& th": {
                                    backgroundColor: "#F8FAFC",
                                    fontWeight: 700,
                                    color: "#334155",
                                    fontSize: "12px",
                                    whiteSpace: "nowrap",
                                    borderBottom: "2px solid #E2E8F0",
                                    padding: "10px 12px",
                                    letterSpacing: "0.02em"
                                }
                            }}>
                                <TableCell align="center" style={{ width: "50px" }}>Sr. No.</TableCell>
                                <TableCell align="left" style={{ minWidth: "160px" }}>Variant Attributes</TableCell>
                                <TableCell align="center" style={{ minWidth: "120px" }}>SKU</TableCell>
                                <TableCell align="center" style={{ minWidth: "160px" }}>Warehouse</TableCell>
                                <TableCell align="center" style={{ minWidth: "100px" }}>HSN</TableCell>
                                <TableCell align="center" style={{ minWidth: "110px" }}>MRP (₹)</TableCell>
                                <TableCell align="center" style={{ minWidth: "110px" }}>Selling Price (₹)</TableCell>
                                <TableCell align="center" style={{ minWidth: "85px" }}>Quantity</TableCell>
                                <TableCell align="center" style={{ minWidth: "100px" }}>UOM</TableCell>
                                <TableCell align="center" style={{ minWidth: "95px" }}>UOM Value</TableCell>
                                <TableCell align="center" style={{ minWidth: "110px" }}>Image</TableCell>
                                <TableCell align="center" style={{ minWidth: "95px" }}>Status</TableCell>
                                <TableCell align="center" style={{ width: "50px" }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData && tableData.length > 0 ? (
                                tableData.map((row: any, index: number) => {
                                    const attributesList = Array.isArray(row.variant_group) && row.variant_group.length > 0
                                        ? row.variant_group
                                        : (Array.isArray(row.attributes) ? row.attributes : []);

                                    const imagesList = Array.isArray(row.image)
                                        ? row.image
                                        : (typeof row.image === "string" && row.image.trim() !== "" ? row.image.split(",") : []);

                                    return (
                                        <TableRow key={index} hover sx={{ "& td": { verticalAlign: "middle", padding: "8px 10px", borderBottom: "1px solid #F1F5F9" } }}>
                                            <TableCell align="center" style={{ fontWeight: 600, color: "#64748B", fontSize: "12px" }}>
                                                {index + 1}
                                            </TableCell>

                                            {/* Attributes list */}
                                            <TableCell align="left">
                                                <div className="d-flex flex-wrap" style={{ gap: "4px" }}>
                                                    {attributesList.length > 0 ? (
                                                        attributesList.map((attr: any, aIdx: number) => (
                                                            <Tag
                                                                key={aIdx}
                                                                style={{
                                                                    margin: 0,
                                                                    fontSize: "11px",
                                                                    fontWeight: 600,
                                                                    backgroundColor: "#EFF6FF",
                                                                    color: "#1D4ED8",
                                                                    border: "1px solid #DBEAFE",
                                                                    borderRadius: "6px",
                                                                    padding: "2px 8px"
                                                                }}
                                                            >
                                                                {(attr.variant_name || attr.name || attr.attribute_name)}: <strong style={{ color: "#0F172A" }}>{String(attr.variant_value || attr.value || attr.attribute_value)}</strong>
                                                            </Tag>
                                                        ))
                                                    ) : (
                                                        <Tag color="default" style={{ borderRadius: "6px" }}>Standard</Tag>
                                                    )}
                                                </div>
                                            </TableCell>

                                            {/* SKU */}
                                            <TableCell align="center">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    style={{ fontSize: "12px", textAlign: "center", borderRadius: "6px", border: "1px solid #CBD5E1" }}
                                                    value={row.sku || ""}
                                                    onChange={(e) => handleFieldChange(index, "sku", e.target.value)}
                                                    placeholder="SKU"
                                                />
                                            </TableCell>

                                            {/* Warehouse Dropdown */}
                                            <TableCell align="center">
                                                <select
                                                    className="form-control form-control-sm"
                                                    style={{ fontSize: "12px", borderRadius: "6px", border: "1px solid #CBD5E1", cursor: "pointer" }}
                                                    value={row.warehouse_id || row.inventories?.[0]?.warehouse_id || ""}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        handleFieldChange(index, "warehouse_id", val);
                                                        const currentQty = Number(row.quantity ?? row.available_qty ?? 0);
                                                        const updatedInvs = [{
                                                            warehouse_id: Number(val) || val,
                                                            quantity: currentQty,
                                                            available_qty: currentQty,
                                                            status: true
                                                        }];
                                                        handleFieldChange(index, "inventories", updatedInvs);
                                                    }}
                                                >
                                                    <option value="">Select Warehouse</option>
                                                    {warehouses && warehouses.map((wh: any, wIdx: number) => {
                                                        const whId = wh.id || wh.warehouse_id;
                                                        const whName = wh.warehouse_name || wh.name || wh.title || (whId ? `Warehouse ${whId}` : `Warehouse #${wIdx + 1}`);
                                                        return (
                                                            <option key={whId || wIdx} value={whId}>
                                                                {whName}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </TableCell>

                                            {/* HSN */}
                                            <TableCell align="center">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    style={{ fontSize: "12px", textAlign: "center", borderRadius: "6px", border: "1px solid #CBD5E1" }}
                                                    value={row.hsn || ""}
                                                    onChange={(e) => handleFieldChange(index, "hsn", e.target.value)}
                                                    placeholder="HSN"
                                                />
                                            </TableCell>

                                            {/* Base Price (MRP) */}
                                            <TableCell align="center">
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    style={{ fontSize: "12px", textAlign: "center", borderRadius: "6px", fontWeight: 600, border: "1px solid #CBD5E1" }}
                                                    value={row.mrp ?? row.base_price ?? ""}
                                                    onChange={(e) => handleFieldChange(index, "mrp", e.target.value)}
                                                    placeholder="MRP"
                                                />
                                            </TableCell>

                                            {/* Selling Price */}
                                            <TableCell align="center">
                                                {(() => {
                                                    const rMrp = Number(row.mrp ?? row.base_price ?? 0);
                                                    const rSell = Number(row.selling_price ?? row.current_price ?? 0);
                                                    const isInvalid = rSell > rMrp && rMrp > 0;
                                                    return (
                                                        <input
                                                            type="number"
                                                            className={`form-control form-control-sm ${isInvalid ? "is-invalid border-danger" : ""}`}
                                                            style={{
                                                                fontSize: "12px",
                                                                textAlign: "center",
                                                                borderRadius: "6px",
                                                                fontWeight: 600,
                                                                color: isInvalid ? "#DC2626" : "#059669",
                                                                border: isInvalid ? "1px solid #DC2626" : "1px solid #CBD5E1"
                                                            }}
                                                            value={row.selling_price ?? row.current_price ?? ""}
                                                            onChange={(e) => handleFieldChange(index, "selling_price", e.target.value)}
                                                            onBlur={() => {
                                                                if (isInvalid) {
                                                                    toast.error("Selling price cannot be greater than MRP price!", { toastId: "selling-price-mrp-error" });
                                                                }
                                                            }}
                                                            placeholder="Selling"
                                                            title={isInvalid ? "Selling price cannot be greater than MRP price!" : ""}
                                                        />
                                                    );
                                                })()}
                                            </TableCell>

                                            {/* Quantity */}
                                            <TableCell align="center">
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    style={{ fontSize: "12px", textAlign: "center", borderRadius: "6px", fontWeight: 600, border: "1px solid #CBD5E1" }}
                                                    value={row.quantity ?? row.available_qty ?? ""}
                                                    onChange={(e) => {
                                                        const qtyVal = e.target.value;
                                                        handleFieldChange(index, "quantity", qtyVal);
                                                        const currentWhId = row.warehouse_id || row.inventories?.[0]?.warehouse_id || 1;
                                                        const updatedInvs = [{
                                                            warehouse_id: Number(currentWhId) || currentWhId,
                                                            quantity: Number(qtyVal) || 0,
                                                            available_qty: Number(qtyVal) || 0,
                                                            status: true
                                                        }];
                                                        handleFieldChange(index, "inventories", updatedInvs);
                                                    }}
                                                    placeholder="Qty"
                                                />
                                            </TableCell>

                                            {/* UOM */}
                                            <TableCell align="center">
                                                <select
                                                    className="form-control form-control-sm"
                                                    style={{ fontSize: "12px", borderRadius: "6px", border: "1px solid #CBD5E1", cursor: "pointer" }}
                                                    value={row.uom || "piece"}
                                                    onChange={(e) => handleFieldChange(index, "uom", e.target.value)}
                                                >
                                                    <option value="piece">Piece</option>
                                                    <option value="unit">Unit</option>
                                                    <option value="dozen">Dozen</option>
                                                    <option value="gram">Gram</option>
                                                    <option value="kilogram">Kilogram</option>
                                                    <option value="litre">Litre</option>
                                                    <option value="millilitre">Millilitre</option>
                                                    <option value="tonne">Tonne</option>
                                                </select>
                                            </TableCell>

                                            {/* UOM Value */}
                                            <TableCell align="center">
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    className="form-control form-control-sm"
                                                    style={{ fontSize: "12px", textAlign: "center", borderRadius: "6px", border: "1px solid #CBD5E1" }}
                                                    value={row.uom_value ?? row.weight ?? row.weights ?? ""}
                                                    onChange={(e) => handleFieldChange(index, "uom_value", e.target.value)}
                                                    placeholder="Val"
                                                />
                                            </TableCell>

                                            {/* Image */}
                                            <TableCell align="center">
                                                {imagesList && imagesList.length > 0 ? (
                                                    <span
                                                        className="badge badge-info"
                                                        style={{ cursor: "pointer", padding: "6px 10px", fontSize: "11px", borderRadius: "6px", backgroundColor: "#EEF2FF", color: "#4F46E5", border: "1px solid #C7D2FE" }}
                                                        onClick={() => handleOpenImageModal(index)}
                                                    >
                                                        🖼️ {imagesList.length} Image(s)
                                                    </span>
                                                ) : (
                                                    <label style={{ margin: 0, cursor: "pointer" }}>
                                                        <span className="badge border" style={{ padding: "6px 10px", fontSize: "11px", borderRadius: "6px", backgroundColor: "#F8FAFC", color: "#475569" }}>
                                                            + Upload
                                                        </span>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            style={{ display: "none" }}
                                                            onChange={(e) => handleImageUpload(e, index)}
                                                        />
                                                    </label>
                                                )}
                                            </TableCell>

                                            {/* Status */}
                                            <TableCell align="center">
                                                <select
                                                    className="form-control form-control-sm"
                                                    style={{
                                                        fontSize: "12px",
                                                        borderRadius: "6px",
                                                        fontWeight: 600,
                                                        cursor: "pointer",
                                                        backgroundColor: row.status !== false ? "#F0FDF4" : "#FEF2F2",
                                                        color: row.status !== false ? "#166534" : "#991B1B",
                                                        border: row.status !== false ? "1px solid #BBF7D0" : "1px solid #FECACA"
                                                    }}
                                                    value={row.status !== false ? "true" : "false"}
                                                    onChange={(e) => handleFieldChange(index, "status", e.target.value === "true")}
                                                >
                                                    <option value="true">Active</option>
                                                    <option value="false">Inactive</option>
                                                </select>
                                            </TableCell>

                                            {/* Action Delete */}
                                            <TableCell align="center">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-link text-danger p-0"
                                                    title="Delete Row"
                                                    onClick={() => handleDeleteRow(index)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <DeleteIcon style={{ fontSize: "18px", color: "#EF4444" }} />
                                                </button>
                                            </TableCell>

                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={13} align="center" style={{ padding: "40px 20px", color: "#94A3B8" }}>
                                        <div style={{ fontSize: "14px", fontWeight: 500 }}>No variants added yet.</div>
                                        <div style={{ fontSize: "12px", color: "#CBD5E1", marginTop: "4px" }}>Select variation options above to generate variant combinations.</div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {/* Bottom Save / Update button */}
            <div className='d-flex justify-content-end align-items-center mt-3' style={{ gap: "10px" }}>
                <button
                    type="button"
                    className="btn btn-success d-flex align-items-center shadow-sm"
                    style={{
                        padding: "8px 24px",
                        borderRadius: "8px",
                        fontWeight: 700,
                        fontSize: "14px",
                        gap: "8px",
                        backgroundColor: "#16A34A",
                        borderColor: "#16A34A"
                    }}
                    disabled={isUpdating || !tableData || tableData.length === 0}
                    onClick={handleSaveClick}
                >
                    <SaveOutlined /> {isUpdating ? "Saving..." : (hasVariants === "true" || id || product?.id ? "Update Variants" : "Submit Variants")}
                </button>
            </div>

            <Modal open={iopen} onClose={() => setiopen(false)}>
                <Box sx={smstyle}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 style={{ margin: 0, fontWeight: 700 }}>Manage Variant Images</h6>
                        <CloseIcon style={{ cursor: "pointer" }} onClick={() => setiopen(false)} />
                    </div>
                    <div>
                        <ImageAdd
                            productImageHandler={(e: any) => handleImageUpload(e, currentImageRowIndex)}
                            productData={tableData[currentImageRowIndex] || {}}
                            imageIndex={currentImageRowIndex}
                            removeImageHandler={handleRemoveImage}
                        />
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
